import ColumnMapper from './ColumnMapper'
import SelectMapper from './SelectMapper'

const mapper = {
  'column': ColumnMapper,
  'select': SelectMapper
}

export default mapper
